import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { includes } from '../../data/content';
export function IncludesSection() {
  return <Section id="incluye" tone="surface" data-id="element-164" data-mp="276gp6n05g4d0">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-165" data-mp="277i2ky4n12xw">
        <SectionTitle className="max-w-3xl" data-id="element-166" data-mp="2c5tcf8uxndg4">
          ¿Qué incluye tu diagnóstico fitness <Accent data-id="element-167" data-mp="2zucgfc6y942e">gratuito?</Accent>
        </SectionTitle>
        <p className="max-w-sm text-lg leading-relaxed text-muted" data-id="element-168" data-mp="2zsrlvmkmxl4j">
          De dónde estás hoy a qué deberías cambiar primero.
        </p>
      </div>

      <ol className="mt-14 grid gap-px overflow-hidden rounded-lg border border-line bg-line md:grid-cols-2 lg:grid-cols-4" data-id="element-169" data-mp="2pvmzblmvnnn7">
        {includes.map((block, i) => {
        const isLast = i === includes.length - 1;
        return <li key={block.title} className={`flex flex-col p-7 sm:p-8 ${isLast ? 'bg-brand' : 'bg-ink'}`} data-id="element-170" data-mp="1ejm7fxupvj38" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-171" data-mp="1h04e9nur3m4o">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full font-display text-xl font-black ${isLast ? 'bg-white text-brand' : 'border border-brand text-brand'}`} data-id="element-172" data-mp="1h0xgcbirlngh">
                  {i + 1}
                </span>
                <span className={`h-px flex-1 ${isLast ? 'bg-white/40' : 'bg-line'}`} aria-hidden="true" data-id="element-173" data-mp="1l0eml760momp" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-174" data-mp="1uzx0b5vc1e6b">{block.title}</h3>
              <p className={`mt-3 leading-relaxed ${isLast ? 'text-white/90' : 'text-muted'}`} data-id="element-175" data-mp="28rtpb11pf7yh">{block.text}</p>
            </li>;
      })}
      </ol>
    </Section>;
}